import React from "react";
import { Upload } from "@phosphor-icons/react";
import { UploadType } from "../../../shared/components/uploadFileModal/uploadFileModal";
import {
  MAX_IMAGE_SOURCE_SIZE,
  MAX_UPLOAD_SIZE,
} from "shared/utils/uploadLimits";

interface FileUploadAreaProps {
  currentUploadType: UploadType;
  onFileChange: (files: File[]) => void;
}

const FileUploadArea: React.FC<FileUploadAreaProps> = ({
  currentUploadType,
  onFileChange,
}) => {
  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files.length) {
      onFileChange(Array.from(files));
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div
        className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-gray-400 transition-colors"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <input
          type="file"
          multiple
          accept={currentUploadType === UploadType.PICTURES ? "image/*" : "*"}
          onChange={(e) => {
            if (e.target.files) {
              onFileChange(Array.from(e.target.files));
            }
          }}
          className="hidden"
          id="file-upload"
        />
        <label htmlFor="file-upload" className="cursor-pointer">
          {/* text-gray-400 is too faint against this white card to read as an
              affordance; the muted foreground token carries real contrast. */}
          <Upload size={48} className="mx-auto mb-4 text-muted-foreground" />
          <p className="text-lg font-medium mb-2">
            Sleep {currentUploadType === UploadType.PICTURES ? 'afbeeldingen' : 'bestanden'} hier of klik om te bladeren
          </p>
          {/* Images are downscaled in the browser before upload, so the 20MB
              backend limit applies to what is sent, not to what is picked here. */}
          <p className="text-sm text-muted-foreground">
            {currentUploadType === UploadType.PICTURES
              ? `Ondersteunt: JPG, PNG, GIF, etc. (max. ${MAX_IMAGE_SOURCE_SIZE / 1024 / 1024} MB, afbeeldingen worden automatisch verkleind)`
              : `Ondersteunt alle bestandstypen (max. ${MAX_UPLOAD_SIZE / 1024 / 1024} MB)`}
          </p>
        </label>
      </div>
    </div>
  );
};

export default FileUploadArea;